export const getQvctCategories = (state) => state.qvctCategories
export const getQvctCategoriesType = (state) => state.qvctCategoriesType

